function isMobile(userAgent?: string): boolean | null {
  if (!userAgent) {
    return null;
  }
  try {
    return /iPad|iPhone|iPod|Android|Tablet|Mobile/.test(userAgent);
  } catch (err) {}
  return null;
}

function appleOrMobile(userAgent?: string): boolean | null {
  if (!userAgent) {
    return null;
  }
  try {
    return /iPad|iPhone|iPod|Tablet|Mobile|Mac|macintosh|Macintosh/.test(userAgent);
  } catch (err) {}
  return null;
}

function deviceWidthHint(userAgent?: string): number | null {
  if (!userAgent) {
    return null;
  }
  try {
    if (/iPad|Tablet/.test(userAgent)) {
      return 1025;
    } else if (/iPhone|iPod|Android|Mobile/.test(userAgent)) {
      return 600;
    }
  } catch (err) {}
  return null;
}

export default {
  isMobile,
  appleOrMobile,
  deviceWidthHint,
};
